import { Button, Text } from '@medly-components/core';
import type { FC } from 'react';

import { FilterHeaderStyled } from './FilterHeader.styled';
import { FilterHeaderProps } from './types';

export const FilterHeader: FC<FilterHeaderProps> = ({ label, onClear, showClear }) => (
    <FilterHeaderStyled>
        <Text textVariant="body2" textWeight="Medium">
            {label}
        </Text>
        {showClear && (
            <Button variant="flat" onClick={onClear} aria-label={`${label} Clear`}>
                <Text textVariant="button2">Clear</Text>
            </Button>
        )}
    </FilterHeaderStyled>
);
FilterHeader.displayName = 'FilterHeader';
